import React from 'react';
import { TabIndex } from './types';

const TABS = ['1. Seleção', '2. Substituição', '3. Talhões'] as const;

interface TabHeaderProps {
  activeTab: TabIndex;
  selectedInsumos: string[];
  substituicoesCompletas: boolean;
  onTabChange: (tab: TabIndex) => void;
}

const TabHeader: React.FC<TabHeaderProps> = ({
  activeTab,
  selectedInsumos,
  substituicoesCompletas,
  onTabChange,
}) => (
  <div className="assistente-tabs">
    {TABS.map((label, idx) => {
      const isDisabled =
        (idx >= 1 && selectedInsumos.length === 0) ||
        (idx === 2 && !substituicoesCompletas);
      return (
        <button
          key={label}
          type="button"
          className={`assistente-tab${
            activeTab === idx ? ' assistente-tab-active' : ''
          }${isDisabled ? ' assistente-tab-disabled' : ''}`}
          onClick={() => !isDisabled && onTabChange(idx as TabIndex)}
          disabled={isDisabled}
        >
          {label}
        </button>
      );
    })}
  </div>
);

export default React.memo(TabHeader);
